import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.config}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}` +
  '/configuration/accountManager';

export interface AccountManagerConfiguration {
  sellerId: string;
  accountStatus: string;
  customerService: boolean;
  liveDateUtc: string;
  lastChangeTimeUtc: string;
  lastChangeUser: string;
}

export interface SetSellerConfigurationAccountManagerCommandArgs {
  sellerId?: string | null;
  accountManagerConfiguration?: AccountManagerConfiguration | null;
}

export const setSellerConfigurationAccountManagerRequest = ({
  sellerId,
  accountManagerConfiguration,
}: SetSellerConfigurationAccountManagerCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId ?? ''),
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { ...accountManagerConfiguration },
  },
});

export const setSellerConfigurationAccountManagerCommand = async (
  payload: SetSellerConfigurationAccountManagerCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(
      setSellerConfigurationAccountManagerRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
